//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'
import { Enums } from '../common'

import { Dictionary } from '../../helpers/dictionary'
import { DataProvider } from '../../helpers/data-provider'
import { ConvertHelper } from '../../helpers/convert-helper'

import { OpDevice, OpSlotType, OpProtocol } from './index'

// TODO: IN PROGRESS

export class OpDeviceHierarchy implements IOpChangeState, IJsonSerializable, ICopyable<OpDeviceHierarchy>
{
    // Properties

    public idDeviceHierarchy: number
    public serialNbrParent: number
    public idSlotType: number
    public slotNbr: number
    public idProtocolIn: number
    public idProtocolOut: number
    public serialNbr: number
    public isActive: boolean
    public startTime: Date
    public endTime: Date

    // Properties End

    // Navigation Properties

    public deviceParent: OpDevice

    public device: OpDevice

    public slotType: OpSlotType

    public protocolIn: OpProtocol

    public protocolOut: OpProtocol

    // Navigation Properties End

    // Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpDeviceHierarchy) {
            this.copy(<OpDeviceHierarchy>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // Ctor End

    // IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // IOpChangeState Implementation End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idDeviceHierarchy = opObj.ID_DEVICE_HIERARCHY
            this.serialNbrParent = opObj.SERIAL_NBR_PARENT
            this.idSlotType = opObj.ID_SLOT_TYPE
            this.slotNbr = opObj.SLOT_NBR
            this.idProtocolIn = opObj.ID_PROTOCOL_IN
            this.idProtocolOut = opObj.ID_PROTOCOL_OUT
            this.serialNbr = opObj.SERIAL_NBR
            this.isActive = opObj.IS_ACTIVE
            this.startTime = opObj.START_TIME ? ConvertHelper.stringToDate(opObj.START_TIME) : null
            this.endTime = opObj.END_TIME ? ConvertHelper.stringToDate(opObj.END_TIME) : null

            this.deviceParent = opObj._DeviceParent ? new OpDevice(opObj._DeviceParent) : null
            this.device = opObj._Device ? new OpDevice(opObj._Device) : null
            this.protocolIn = opObj._ProtocolIn ? new OpProtocol(opObj._ProtocolIn) : null
            this.protocolOut = opObj._ProtocolOut ? new OpProtocol(opObj._ProtocolOut) : null
            this.slotType = opObj._SlotType ? new OpSlotType(opObj._SlotType) : null

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DEVICE_HIERARCHY: this.idDeviceHierarchy,
            SERIAL_NBR_PARENT: this.serialNbrParent,
            ID_SLOT_TYPE: this.idSlotType,
            SLOT_NBR: this.slotNbr,
            ID_PROTOCOL_IN: this.idProtocolIn,
            ID_PROTOCOL_OUT: this.idProtocolOut,
            SERIAL_NBR: this.serialNbr,
            IS_ACTIVE: this.isActive,
            START_TIME: this.startTime ? ConvertHelper.dateToString(this.startTime, { netFormat: true }) : null,
            END_TIME: this.endTime ? ConvertHelper.dateToString(this.endTime, { netFormat: true }) : null,
            OpState: this.opState
        }
    }

    // IJsonSerializable Implementation End

    public toString() {
        return this.idDeviceHierarchy
    }

    //#region ICopyable Implementation

    public copy(source: OpDeviceHierarchy, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        // No datalist

        if (includeNavigationProperties) {
            this.deviceParent = source.deviceParent // TODO: Copy methods for those types
            this.device = source.device             // TODO: Copy methods for those types
            this.protocolIn = source.protocolIn     // TODO: Copy methods for those types
            this.protocolOut = source.protocolOut   // TODO: Copy methods for those types
            this.slotType = source.slotType         // TODO: Copy methods for those types
        }

        if (includeCustomProperties) {

        }

        // No datalist
        // No dynamicValues

        this.idDeviceHierarchy = source.idDeviceHierarchy
        this.serialNbrParent = source.serialNbrParent
        this.idSlotType = source.idSlotType
        this.slotNbr = source.slotNbr
        this.idProtocolIn = source.idProtocolIn
        this.idProtocolOut = source.idProtocolOut
        this.serialNbr = source.serialNbr
        this.isActive = source.isActive
        this.startTime = source.startTime
        this.endTime = source.endTime

        this.opState = source.opState
    }


    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpDeviceHierarchy {
        const deviceHierarchy: OpDeviceHierarchy = new OpDeviceHierarchy(null)

        deviceHierarchy.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return deviceHierarchy
    }

    //#endregion


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDeviceHierarchy[]): JQueryPromise<OpDeviceHierarchy[]> {
        var defered = $.Deferred<OpDeviceHierarchy[]>()

        if (dataProvider && list && list.length > 0) {
            dataProvider
                .System
                .getDictionaries([Enums.ReferenceType.IdProtocol, Enums.ReferenceType.IdSlotType])
                .then(dict => {
                    let protocolDict: Dictionary<OpProtocol> = new Dictionary<OpProtocol>(null)
                    let slotTypeDict: Dictionary<OpSlotType> = new Dictionary<OpSlotType>(null)

                    if (dict.containsKey(Enums.ReferenceType.IdProtocol)) {
                        protocolDict = <Dictionary<OpProtocol>>dict.tryGetValue(Enums.ReferenceType.IdProtocol)
                    }

                    if (dict.containsKey(Enums.ReferenceType.IdSlotType)) {
                        slotTypeDict = <Dictionary<OpSlotType>>dict.tryGetValue(Enums.ReferenceType.IdSlotType)
                    }

                    list.forEach(item => {
                        if (item.idProtocolIn) {
                            item.protocolIn = protocolDict.tryGetValue(item.idProtocolIn)
                        }

                        if (item.idProtocolOut) {
                            item.protocolOut = protocolDict.tryGetValue(item.idProtocolOut)
                        }

                        if (item.idSlotType) {
                            item.slotType = slotTypeDict.tryGetValue(item.idSlotType)
                        }
                    })

                    defered.resolve(list)
                })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }
}